export type AccessPermissionType = 'anyone' | 'only-me' | 'selected-users';
export interface AccessPermissionMeta {
  value: AccessPermissionType;
  label: string;
}

export const ACCESS_PERMISSIONS: Record<
  AccessPermissionType,
  AccessPermissionMeta
> = {
  anyone: {
    value: 'anyone',
    label: 'Anyone',
  },
  'only-me': {
    value: 'only-me',
    label: 'Only Me',
  },
  'selected-users': {
    value: 'selected-users',
    label: 'Selected Users',
  },
};
